// TEMPORARY
const codeMaps = {
	404: 'User does not exist'
};

export const handleAxiosError = (error) => {
	const errorCode = error;

	if (errorCode) {
		const mappedCode = codeMaps[errorCode];
		throw new Error(mappedCode || 'Request failed. Please try again.');
	} else {
		throw new Error('Request failed. Please try again.');
	}
};
